import React, { useState, forwardRef } from "react";

import { InputText } from "primereact/inputtext";
import MeaCreateModal from "../../../components/MeaCreateModal";
import { InputTextarea } from "primereact/inputtextarea";
import trainingsAPI from "../../../services/trainings";
import { Calendar } from "primereact/calendar";

const CreateTrainingModal = forwardRef((props, ref) => {
  //
  const [name, setName] = useState("");
  const [presentation, setPresentation] = useState("");
  const [trainingStartDate, setTrainingStartDate] = useState("");
  const [trainingEndDate, setTrainingEndDate] = useState("");
  const [registrationStartDate, setRegistrationStartDate] = useState("");
  const [registrationEndDate, setRegistrationEndDate] = useState("");
  //
  return (
    <>
      <MeaCreateModal
        ref={ref}
        title="Créer une nouvelle formation"
        serviceAPI={trainingsAPI}
        schoolId={props.schoolId}
        trainingId={props.trainingId}
        accessToken={props.accessToken}
        data={{
          name: name,
          presentation: presentation,
          start_courses_date:
            trainingStartDate !== ""
              ? new Date(trainingStartDate).toISOString()
              : null,
          end_courses_date:
            trainingEndDate !== ""
              ? new Date(trainingEndDate).toISOString()
              : null,
          start_registration_date:
            registrationStartDate !== ""
              ? new Date(registrationStartDate).toISOString()
              : null,
          end_registration_date:
            registrationEndDate !== ""
              ? new Date(registrationEndDate).toISOString()
              : null,
        }}
      >
        <label htmlFor="name" className="block text-900 font-medium mb-2">
          Nom du évènement
        </label>
        <InputText
          id="name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full mb-3"
          autoFocus
        />
        <label
          htmlFor="presentation"
          className="block text-900 font-medium mb-2"
        >
          Présentation
        </label>
        <InputTextarea
          id="presentation"
          type="text"
          value={presentation}
          onChange={(e) => setPresentation(e.target.value)}
          rows={3}
          className="w-full mb-3"
        />
        <div className="grid formgrid p-fluid">
          <div className="field mb-4 col-12 md:col-6">
            <label htmlFor="registration_start" className="font-medium text-900">Début des inscriptions</label>
            <Calendar locale="fr" value={registrationStartDate ? new Date(registrationStartDate) : ""} onChange={(e) => setRegistrationStartDate(e.value)} dateFormat="dd/mm/yy" id="registration_start" showIcon />
          </div>
          <div className="field mb-4 col-12 md:col-6">
            <label htmlFor="registration_end" className="font-medium text-900">Fin des inscriptions</label>
            <Calendar locale="fr" value={registrationEndDate ? new Date(registrationEndDate) : ""} onChange={(e) => setRegistrationEndDate(e.value)} dateFormat="dd/mm/yy" id="registration_end" showIcon />
          </div>
          <div className="field mb-4 col-12 md:col-6">
            <label htmlFor="training_start" className="font-medium text-900">Début des cours</label>
            <Calendar locale="fr" value={trainingStartDate ? new Date(trainingStartDate) : ""} onChange={(e) => setTrainingStartDate(e.value)} dateFormat="dd/mm/yy" id="training_start" showIcon />
          </div>
          <div className="field mb-4 col-12 md:col-6">
            <label htmlFor="training_end" className="font-medium text-900">Fin des cours</label>
            <Calendar locale="fr" value={trainingEndDate ? new Date(trainingEndDate) : ""} onChange={(e) => setTrainingEndDate(e.value)} dateFormat="dd/mm/yy" id="training_end" showIcon />
          </div>
        </div>
        {/* <p>
          La formation aura un status{" "}
          <Tag severity="warning" value="EN PREPARATION"></Tag> par défault.
          Vous devriez compléter son contenue avant de l'activer et donc le
          rendre disponible aux différents utilisateurs concernés.
        </p> */}
      </MeaCreateModal>
    </>
  );
});

export default CreateTrainingModal;
